import Resources, { IResource, IResourceApiModel } from './Resource.model';

export interface IProductResources {
  id: number;
  resourcesId: string;
  resource: IResource;
}

export interface IProductResourcesApiModel {
  id: number;
  resourcesId: string;
  resource: IResourceApiModel;
}

export default class ProductResources implements IProductResources {
  public readonly id: number;

  public readonly resourcesId: string;

  public readonly resource: IResource;

  constructor(id: number, resourcesId: string, resource: IResource) {
    this.id = id;
    this.resourcesId = resourcesId;
    this.resource = resource;
  }

  static fromApiModel(apiModel: IProductResourcesApiModel) {
    const { id, resourcesId } = apiModel;

    const resource = Resources.fromApiModel(apiModel.resource);
    return new ProductResources(id, resourcesId, resource);
  }

  static arrayFromApiModel(arrayApiModel: IProductResourcesApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      const { id, resourcesId } = apiModel;

      const resource = Resources.fromApiModel(apiModel.resource);

      return new ProductResources(id, resourcesId, resource);
    });

    return array;
  }
}
